module.exports = __webpack_public_path__ + "img/footer6.ad2c8971.jpg";